import BaseService from 'services/BaseService';

//-------------------------------------------------------------------------------------------------------------------

export default class JobRequestService
    extends BaseService {

    static async listMonths(type) {
        return BaseService.callAPI('job-request/list-months/' + type);
    }

    static async list(param) {
        return BaseService.callAPI('job-request/list', param);
    }

    static async get(id) {
        return BaseService.callAPI('job-request/get/' + id);
    }

    static async listMatchingInstructors(jobRequest) {
        //jobRequest = { ...jobRequest };
        return BaseService.callAPI('job-request/list-matching-instructors', jobRequest);
    }

    static async save(jobRequest) {
        return BaseService.callAPI('job-request/save', jobRequest);
    }

    static async notify(id) {
        return BaseService.callAPI('job-request/notify/' + id);
    }

    static async delete(id) {
        return BaseService.callAPI('job-request/delete/' + id);
    }

}
